import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "text-caption text-medium-emphasis mb-0" }
const _hoisted_4 = { class: "text-start" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "text-caption text-medium-emphasis mb-0" }
const _hoisted_7 = { class: "text-start" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "px-0 pt-2" }
const _hoisted_14 = { class: "text-subtitle-1 mb-2 text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "mvr-summary pa-4",
    "aria-label": "MVR Summary"
  }, {
    default: _withCtx(() => [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-h6 mb-2 text-start pa-0" }, "MVR Summary Details", -1 /* HOISTED */)),
      _createCommentVNode(" Driver + License Info "),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, [
                  _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Name:", -1 /* HOISTED */)),
                  _createTextVNode(" " + _toDisplayString($setup.driverName), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_3, " DOB: " + _toDisplayString($setup.summaryData?.driverInfo?.dob ? $setup.formatDate($setup.summaryData.driverInfo.dob, 'MM/DD/YYYY') : '—') + " | Gender: " + _toDisplayString($setup.getGenderText($setup.summaryData?.driverInfo?.gender)), 1 /* TEXT */)
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("strong", null, "DL#:", -1 /* HOISTED */)),
                  _createTextVNode(" " + _toDisplayString($setup.summaryData?.driverInfo?.licenseNumber) + " (" + _toDisplayString($setup.summaryData?.driverInfo?.licenseState) + ") ", 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_6, [
                  _createTextVNode(" Class: " + _toDisplayString($setup.summaryData?.driverInfo?.dlClass || '—') + " | Status: ", 1 /* TEXT */),
                  _createVNode(_component_v_chip, {
                    color: $setup.summaryData?.licenceStatus?.toUpperCase() === 'VALID' ? 'success' : 'error',
                    class: "ml-1 text-white",
                    size: "small",
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.summaryData?.licenceStatus?.toUpperCase() || 'UNKNOWN'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["color"])
                ])
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_divider, { class: "my-4" }),
      _createCommentVNode(" MVR Status Info "),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Order Id:", -1 /* HOISTED */)),
                  _createTextVNode(" " + _toDisplayString($setup.summaryData?.orderId || '—'), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Status:", -1 /* HOISTED */)),
                  _createTextVNode(" " + _toDisplayString($setup.summaryData?.status || '—'), 1 /* TEXT */)
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Ordered:", -1 /* HOISTED */)),
                  _createTextVNode(" " + _toDisplayString($setup.summaryData?.dateTimeOrdered ? $setup.formatDate($setup.summaryData.dateTimeOrdered, 'MM/DD/YYYY') : '—'), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_12, [
                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Completed:", -1 /* HOISTED */)),
                  _createTextVNode(" " + _toDisplayString($setup.summaryData?.dateTimeCompleted ? $setup.formatDate($setup.summaryData.dateTimeCompleted, 'MM/DD/YYYY') : '—'), 1 /* TEXT */)
                ])
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_divider, { class: "my-4" }),
      _createCommentVNode(" Records "),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, " Records (" + _toDisplayString($setup.totalRecords) + ") ", 1 /* TEXT */),
        _createVNode(_component_v_data_table, {
          headers: $setup.headers,
          items: $setup.allRecords,
          class: "text-left",
          density: "compact",
          hover: "",
          color: "primaryMoe",
          "items-per-page": 10,
          "sort-by": [{key: 'date', order: 'asc'}],
          "footer-props": {
          itemsPerPageOptions: [5, 10, 25, -1],
          itemsPerPageText: 'Records per page:',
          showFirstLastPage: true
        }
        }, {
          "item.date": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(item.date ? $setup.formatDate(item.date,'MM/DD/YYYY') : '—'), 1 /* TEXT */)
          ]),
          "item.chargeable": _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              color: $setup.getChargeableChipColor(item.caseStatusIndicator || ''),
              size: "small",
              label: "",
              class: "text-white"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.chargeable), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"])
          ]),
          "item.convictionDate": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(item.convictionDate ? $setup.formatDate(item.convictionDate, 'MM/DD/YYYY') : '—'), 1 /* TEXT */)
          ]),
          "no-data": _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "text-center text-medium-emphasis py-4" }, " No records found. ", -1 /* HOISTED */)
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["headers", "items"])
      ]),
      ($setup.summaryData?.alertMessages?.code === 'SF')
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            title: "Security Freeze",
            class: "sc text-left mt-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.summaryData?.alertMessages?.message), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}